/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_User_Email_TakenInputs */

const en_error_user_email_taken = /** @type {(inputs: Error_User_Email_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another user already has this email.`)
};

/**
* | output |
* | --- |
* | "Another user already has this email." |
*
* @param {Error_User_Email_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_user_email_taken = /** @type {((inputs?: Error_User_Email_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_User_Email_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_user_email_taken(inputs)
});